'use client';

import { useState, useEffect } from 'react';
import { getFeatureModalData, ModalData } from '@/actions/directus';
import Modal from '@/components/common/Modal';
import Button from './Button';
import { faChevronsUp, faRightToBracket, faTags } from '@fortawesome/pro-duotone-svg-icons';
import { getSourcePath } from '@/rewrites';
import Link from 'next/link';
import { closeModal, FeatureType } from '@/slices/features/modalSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useAuthenticated } from '@/hooks/useAuthenticated';
import type { RootState } from '@/slices/store';

const FeatureModal = () => {
  const dispatch = useDispatch();
  const { isOpen, featureType } = useSelector((state: RootState) => state.modal);
  const { isAuthenticated } = useAuthenticated();
  const [modalData, setModalData] = useState<ModalData | null>(null);
  const withButtons = featureType !== FeatureType.SEARCH_INDICATOR;

  useEffect(() => {
    const fetchModalData = async () => {
      if (featureType) {
        const data = await getFeatureModalData(featureType);
        if (data) {
          setModalData(data);
        }
      }
    };

    if (isOpen && featureType) {
      fetchModalData();
    } else {
      setModalData(null);
    }
  }, [featureType, isOpen]);

  if (!modalData) return null;

  const handleClose = () => {
    setModalData(null);
    dispatch(closeModal());
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} icon={modalData.icon} title={modalData.title}>
      <div className="flex flex-col gap-4 overflow-hidden">
        <div
          className="cms-content overflow-y-auto xs:max-w-[60vw] sm:max-w-[50vw] md:max-w-[40vw] lg:max-w-[30vw]"
          dangerouslySetInnerHTML={{ __html: modalData.content }}
        />
        {withButtons && (
          <div className="flex justify-end">
            {isAuthenticated ? (
              <Link href={getSourcePath('/subscription')} onClick={handleClose}>
                <Button variant="primary" label="Upgrade" icon={faChevronsUp} />
              </Link>
            ) : (
              <div className="flex gap-2">
                <Link href={getSourcePath('/pricing')} onClick={handleClose}>
                  <Button label="Preise" icon={faTags} />
                </Link>
                <Link href={getSourcePath('/registration')} target="_blank">
                  <Button
                    variant="primary"
                    label={window.innerWidth < 410 ? 'Registrieren' : 'Kostenlos registrieren'}
                    icon={faRightToBracket}
                  />
                </Link>
              </div>
            )}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default FeatureModal;
